export { default } from './ReportcenterWidgetWithFetch';
